/**
 * Espelha marcos do funil no Hotjar (`hj('event')`) e identifica a gravação
 * pelo patientId (`hj('identify')`), para achar no Hotjar a sessão de um
 * paciente visto na telemetria first-party.
 *
 * Só o patientId (pseudônimo) sai daqui: nenhum atributo é enviado. Nome,
 * CPF, telefone, e-mail ou dado clínico NÃO podem entrar no identify nem no
 * nome do evento — o Hotjar é operador fora do plano de proteção de dados
 * para dado sensível. Médico, suporte e admin não são identificados.
 */

export const HOTJAR_MIRRORED_EVENTS = new Set([
  'name_confirmed',
  'email_confirmed',
  'email_confirmed_double_entry',
  'cpf_confirmed',
  'phone_confirmed',
  'terms_accept',
  'triage_started',
  'triage_skip_used',
  'triage_finalize_success',
  'paywall_opened',
  'paywall_pix_qr_shown',
  'paywall_pix_copy_click',
  'paywall_pix_ticket_url_click',
  'paywall_pix_idle_help_shown',
  'paywall_checkout_exit',
  'paywall_closed_by_back',
  'payment_confirmed',
  'payment_poll_error',
  'chat_composer_tap_unpaid',
  'email_access_blocked',
  'email_paid_dup_redirect',
]);

let identifiedAs = null;

/** Fila padrão do snippet do Hotjar: chamadas antes do script carregar ficam em `hj.q`. */
function hj(...args) {
  if (typeof window === 'undefined') return;
  window.hj = window.hj || function hjQueue() {
    (window.hj.q = window.hj.q || []).push(arguments);
  };
  window.hj(...args);
}

export function mirrorUxEventToHotjar(eventName, context) {
  try {
    if (!HOTJAR_MIRRORED_EVENTS.has(eventName)) return;
    if (!context || context.role !== 'patient') return;
    const userId = String(context.user_id || '');
    if (userId.startsWith('patient-') && userId !== identifiedAs) {
      hj('identify', userId, {});
      identifiedAs = userId;
    }
    hj('event', eventName);
  } catch {}
}

export function resetHotjarBridgeForTests() {
  identifiedAs = null;
}
